module.exports = __webpack_public_path__ + "static/media/Memories.b31a4d65.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Memories.ttf
// module id = 2118
// module chunks = 53